import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import OpeningPage from './OpeningPage';
import QuizPage from './QuizPage';
import chineseData from './data/chineseData';  // Assuming this is your data import
import { LevelUnitProvider } from './context/LevelUnitContext';


function App() {
  const [quizStarted, setQuizStarted] = useState(false);
  const [currentQuestion, setCurrentQuestion] = useState(0);

  const startQuiz = () => {
    setCurrentQuestion(100);
    setQuizStarted(true);
  };

  return (

    <BrowserRouter basename="/quiz">
      <Routes>
        <Route path="/" element={
          <LevelUnitProvider>
            <div className="App">
              {!quizStarted ? (
                <OpeningPage onStart={startQuiz} />
              ) : (
                <QuizPage data={chineseData[currentQuestion]} />
              )}
            </div>
          </LevelUnitProvider>
        } />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
